import ConsolidatedShippingFormFields from './consolidated-shipping-form-fields'
import ConsolidatedShippingSubtext from './consolidated-shipping-subtext'

export { ConsolidatedShippingSubtext }
export default ConsolidatedShippingFormFields
